export default __webpack_public_path__ + "static/media/bbcasino.a94270e7.png";